import { z } from 'zod';
import { makeFieldSchemaFromZod } from '@backstage/plugin-scaffolder';

// @ts-ignore
const IdPickerFieldSchema = makeFieldSchemaFromZod(z.string());

export const IdPickerSchema = IdPickerFieldSchema.schema;

export type IdPickerProps = typeof IdPickerFieldSchema.type;
